import { useLayoutEffect, useRef } from 'react';
import * as THREE from 'three';
import type { MatsProps } from './truck/materials';
import { useTruckTextures } from './truck/textures';
import { TRUCK_Y } from './truck/layout';
import { Body } from './truck/Body';
import { Cab } from './truck/Cab';
import { Wheels } from './truck/Wheels';
import { RearDoors } from './truck/RearDoors';
import { BarSide } from './truck/BarSide';
import { Decals } from './truck/Decals';

/**
 * Stylized Piaggio-Ape mobile prosecco bar, built entirely from primitives.
 * Colours and toggles are driven by the Zustand config store via the material set.
 * Suspends until the logo asset is decoded (see useTruckTextures).
 */
export function Truck({ mats }: MatsProps) {
  const tex = useTruckTextures();
  const ref = useRef<THREE.Group>(null);

  useLayoutEffect(() => {
    ref.current?.traverse((o) => {
      const m = o as THREE.Mesh;
      if (!m.isMesh) return;
      m.receiveShadow = true;
      const mat = m.material as THREE.Material | undefined;
      m.castShadow = !!mat && !mat.transparent && mat.type !== 'MeshBasicMaterial';
    });
  });

  return (
    <group ref={ref} position={[0, TRUCK_Y, 0]}>
      <Body mats={mats} />
      <Cab mats={mats} />
      <Wheels mats={mats} />
      <RearDoors mats={mats} />
      <BarSide mats={mats} tex={tex} />
      {tex && <Decals tex={tex} />}
    </group>
  );
}
